export default __webpack_public_path__ + "static/media/thumbnail_summaryvideo.53380bf6.png";